import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const DoubleTrackIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Double track - two parallel paths */}
    <path d="M8 4c0 4-4 4-4 8s4 4 4 8" />
    <path d="M16 4c0 4 4 4 4 8s-4 4-4 8" />
    <path d="M8 4h8" />
    <path d="M8 20h8" />
    <path d="M4 12h16" />
  </svg>
);
